require('./button/button.scss');
var SIZES = {
    NONE: 'NONE',
    DEFAULT: 'DEFAULT',
    SMALL: 'SMALL',
    LARGE: 'LARGE'
};

var SIZE_CLASSNAMES = {
    NONE: '',
    DEFAULT: '',
    SMALL: 'btn-sm',
    LARGE: 'btn-lg'
};

var THEMES = {
    NONE: 'NONE',
    DEFAULT: 'DEFAULT',
    WARNING: 'WARNING',
    DANGER: 'DANGER',
    PRIMARY: 'PRIMARY',
    SUCCESS: 'SUCCESS'
};

var THEME_CLASSNAMES = {
    NONE: '',
    DEFAULT: 'btn btn-default',
    WARNING: 'btn btn-warning',
    DANGER: 'btn btn-danger',
    PRIMARY: 'btn btn-primary',
    SUCCESS: 'btn btn-success'
};

var ICON_THEMES = {
    NONE: 'NONE',
    PLUS: 'PLUS'
};

var ICON_THEME_CLASSNAMES = {
    NONE: '',
    PLUS: 'glyphicon glyphicon-plus-sign'
};

var Button = Marionette.ItemView.extend({
    template: require('./button/button.tpl'),
    className: function () {
        var classNames = ['tl-button'];
        var sizeClassName = SIZE_CLASSNAMES[this.options.size];
        if (sizeClassName) {
            classNames.push(sizeClassName);
        }
        var themeClassName = THEME_CLASSNAMES[
            this.state &&
            this.state.get('theme') ||
            this.options.theme
        ];
        if (themeClassName) {
            classNames.push(themeClassName);
        }
        if (this.options.classNames) {
            classNames = classNames.concat(this.options.classNames);
        }
        return classNames.join(' ');
    },
    iconClassName: function () {
        var classNames = ['tl-icon'];
        var themeClassName = ICON_THEME_CLASSNAMES[this.options.iconTheme];
        if (themeClassName) {
            classNames.push(themeClassName);
        }
        if (this.options.iconClassNames) {
            classNames = classNames.concat(this.options.iconClassNames);
        }
        return classNames.join(' ');
    },
    ui: {
        icon: '.tl-icon'
    },
    events: {
        'click': '_onClicked'
    },
    tagName: 'button',
    _onClicked: function (e) {
        var isEnabled = this.state.get('enabled');
        if (!this.options.multiClick) {
            this.toggledEnabledState(false);
        }
        if (isEnabled) {
            if (this.options.onClickedCallback) {
                this.options.onClickedCallback(this, e);
            }
            this.trigger('clicked');
        }
    },
    initialize: function (options) {
        this.options = _.defaults(
            options || {},
            {
                enabled: true,
                label: '',
                theme: THEMES.DEFAULT,
                size: SIZES.DEFAULT,
                classNames: '',
                showIcon: false,
                iconTheme: ICON_THEMES.NONE,
                iconClassNames: '',
                multiClick: true,
                onClickedCallback: null
            }
        );
        this.state = new Backbone.Model({
            enabled: this.options.enabled,
            label: this.options.label,
            showIcon: this.options.showIcon,
            iconClassNames: this.options.iconClassNames,
            theme: this.options.theme
        });
        this.listenTo(this.state, 'change:theme', this.render);
    },
    isEnabled: function () {
        return this.state.get('enabled');
    },
    setLabel: function (val) {
        this.state.set('label', val);
        this.$el.text(val);
    },
    setTheme: function (val) {
        this.state.set('theme', val);
    },
    toggledEnabledState: function (enabled) {
        if (enabled) {
            this.state.set('enabled', true);
            this.$el.removeClass('disabled');
        } else {
            this.state.set('enabled', false);
            this.$el.addClass('disabled');
        }
    },
    onRender: function () {
        // Calling this here because when backbone calls it
        // the options hash has not been set yet (i.e.
        // initialize has not been called at the time that
        // backbone calls className function)
        this.$el.attr('class', this.className());
        if (this.options.showIcon) {
            this.ui.icon.attr('class', this.iconClassName());
        }
        this.toggledEnabledState(this.state.get('enabled'));
    },
    serializeData: function () {
        return {
            state: this.state.toJSON(),
            theme: THEME_CLASSNAMES[this.options.theme]
        };
    }
});

module.exports = {
    Button: Button,
    THEMES: THEMES,
    ICON_THEMES: ICON_THEMES,
    SIZES: SIZES
};



/*****************
 ** WEBPACK FOOTER
 ** ./assets/vendor/treeline-shared-components/button.js
 ** module id = 62
 ** module chunks = 1 2 3 4 7 8 9 15 18 19 24 27 28 30 33 46 51 80 83 94 106 111 132 146 207
 **/